<template>
	<Icon v-bind="$props">
		<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
			<path
				class="light"
				d="M378.1 16.72C403.8-9.531 448 8.069 448 44.23V435.8C448 471.9 403.8 489.5 378.1 463.3L355.1 438.1C311.8 392.4 254.1 363.3 192 355.4V456C192 486.9 166.9 512 136 512H120C89.07 512 64 486.9 64 456V352C28.65 352 0 323.3 0 287.1V191.1C0 156.7 28.65 127.1 64 127.1H143.6L172.8 126.4C242.1 122.5 307.4 92.28 355.1 41.86L378.1 16.72zM416 44.23C416 36.1 407.2 33.48 402.2 38.73L378.4 63.87C336.5 108 282.7 138.4 224 151.5V328.5C282.7 341.6 336.5 371.1 378.4 416.1L402.2 441.3C407.2 446.5 416 443 416 435.8L416 44.23zM192 323.1V156.9C186.2 157.5 180.4 158 174.5 158.3L144.4 159.1H64C46.33 159.1 32 174.3 32 191.1V287.1C32 305.7 46.33 319.1 64 319.1H144.4L174.5 321.7C180.4 321.1 186.2 322.5 192 323.1V323.1zM96 352V456C96 469.3 106.7 480 120 480H136C149.3 480 160 469.3 160 456V352.9L143.6 352H96zM496 191.1C504.8 191.1 512 199.2 512 207.1V271.1C512 280.8 504.8 287.1 496 287.1C487.2 287.1 480 280.8 480 271.1V207.1C480 199.2 487.2 191.1 496 191.1V191.1z"
			/>
			<path
				class="regular"
				d="M200.7 128C270.7 128 337.9 100.2 387.4 50.68L425.4 12.69C445.5-7.472 480 6.805 480 35.31V179.6C498.6 188.4 512 212.1 512 240C512 267.9 498.6 291.6 480 300.4V444.7C480 473.2 445.5 487.5 425.4 467.3L387.4 429.3C339.6 381.5 275.4 353.1 208 352.1V456C208 486.9 182.9 512 152 512H120C89.07 512 64 486.9 64 456V352C28.65 352 0 323.3 0 288V192C0 156.7 28.65 128 64 128L200.7 128zM432 73.94L421.3 84.62C364.5 141.4 288.1 174 208 175.9V304.1C288.1 305.1 364.5 338.6 421.3 395.4L432 406.1V73.94zM112 456C112 460.4 115.6 464 120 464H152C156.4 464 160 460.4 160 456V352H112V456zM48 192V288C48 296.8 55.16 303.1 64 303.1H160V176H64C55.16 176 48 183.2 48 192V192z"
			/>
		</svg>
	</Icon>
</template>

<script>
import Icon, { props } from './Icon'
export default {
	name: 'BullhornIcon',
	components: { Icon },
	props,
}
</script>
